import { render, staticRenderFns } from "./menuLaboratorio.vue?vue&type=template&id=6b8f3ad0&scoped=true"
import script from "./menuLaboratorio.vue?vue&type=script&lang=js"
export * from "./menuLaboratorio.vue?vue&type=script&lang=js"
import style0 from "./menuLaboratorio.vue?vue&type=style&index=0&id=6b8f3ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f3ad0",
  null
  
)

export default component.exports